// -- CONST
import { Route } from "v2/api/classes/route";
import { authRoutes } from "./routesGroups/authRoutes";
import { nonAuthRoutes } from "./routesGroups/nonAuthRoutes";

export const allRoutes = [
  ...Object.values(nonAuthRoutes),
  ...Object.values(authRoutes),
] as Route<any>[];
